module.exports = __webpack_public_path__ + "static/what-is-refinancing-1735f9cb7d88c5485b2b2e82b1c3aa54.png";